export const IconStop = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      d="M8.5 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5L0
   8.5C0 8.89782 0.158035 9.27936 0.43934 9.56066C0.720644 9.84196 1.10218 10 1.5 10H8.5C8.89782 10 9.27936
    9.84196 9.56066 9.56066C9.84196 9.27936 10 8.89782 10 8.5V1.5C10 1.10218 9.84196 0.720644 9.56066 0.43934C9.27936
     0.158035 8.89782 0 8.5 0Z"
      fill="white"
    />
  </svg>
)
